import React from "react";
import Header from "../../components/header";

const Category = () => {
  return (
    <div className="screen-box">
      <div className="main-box">
        <div className="main-txt">
          <Header
            btn
            header="Categories"
            onBtnClick={() => console.log("hello")}
          />
        </div>
      </div>
    </div>
  );
};

export default Category;
